<template>
    <v-dialog
        v-model="dialog"
        fullscreen
        hide-overlay
        :retain-focus="false"
        persistent
        transition="dialog-bottom-transition">
        <template v-slot:activator="{ on, attrs }">
            <v-btn 
                v-bind="attrs"
                v-on="on" 
                x-medium
                large block 
                rounded 
                color="primary"
                dark>
                {{ $t('happinessTips.label.addCategories.title') }}
            </v-btn>
        </template>
        <v-card>
            <v-toolbar
              dark
              color="secondary">
                <v-btn
                    icon
                    dark
                    class="btn btn-primary"
                    @click="dialog = false">
                    <v-icon>mdi-close</v-icon>
                </v-btn>
                
                <v-toolbar-title>{{ $t('happinessTips.label.addCategories.title') }}</v-toolbar-title>

                <template v-slot:extension>
                  <v-tabs v-model="tab" align-with-title>
                    <v-tabs-slider color="accent"></v-tabs-slider>

                    <v-tab v-for="item in items" :key="item">
                      {{ item }}
                    </v-tab>
                  </v-tabs>
                </template> 

            </v-toolbar>

            <v-tabs-items v-model="tab" class="container mt-5">
              
              <v-tab-item>
                <div class="container mt-4">
                  <formAddHappinessTipsCategories/>
                </div>
              </v-tab-item>

          </v-tabs-items>
  
        </v-card>
    </v-dialog>
  
</template>
  
<script>

  import formAddHappinessTipsCategories from '@/views/happiness-tips/pages/add_happiness-tips-categories/components/form_add_happiness_tips_categories_component.vue';
  import  EventBus  from '@/utils/event_bus.js';

  export default {
    name:"addHappinessTipsCategoriesPage",
    components: {
      formAddHappinessTipsCategories,
    },
    data () {
      return {
        dialog: false,
        tab: null,
        items: [
          this.$t('label.tab')
        ],
      }
    },
    watch: {
      dialog(newVal) {
        if (!newVal) {
          EventBus.$emit('clear-happiness-tips-categories-form');
        }
      }
    },
    async mounted() {
      EventBus.$on('formHappinessTipsCategories-submitted-successfully', () => {
        this.closeDialog()
        EventBus.$emit('reload-happiness-tips-categories');
      });
    },
    methods: {
      closeDialog() {
        this.dialog = false;
        window.location.reload();
      },
    },
  };
</script>

